import React, { Fragment, useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
// Material UI
import {
    Typography,
    Grid
} from '@mui/material';
// Components
import { Button } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
import Pill from 'Components/Pill';

// Actions
import {
    deleteDriversTag,
    clearRedux
} from "Redux/actions";

import { closeDriversTagDeleteModal } from '../../redux/slice';

const DeleteDriversTag = (props) => {
    // Intl
    const { messages } = useIntl();

    //props 
    const { callback } = props;

    // Hooks
    const dispatch = useDispatch();

    // State local
    const loading = useSelector(state => state.driverRedux.loading);
    const open = useSelector(state => state.driverTagsSliceRedux.openDriversTagDelete);
    const loadingDelete = useSelector(state => state.driverTagsSliceRedux.loadingDriversTagDelete);
    const response = useSelector(state => state.driverTagsSliceRedux.driversTagDeleteResponse);
    const items = useSelector(state => state.driverTagsSliceRedux.entity); 

    useEffect(() => {
        if (response && open) {
            if (response?.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
                dispatch(clearRedux("SETTINGS_DRIVER", { response: null }));
            } else {
                NotificationManager.success(
                    messages['settingsDriver_deletedDriversTag'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );
                if (callback) callback();
                handleClose();
            }
        }
    }, [response, open]);

    const handleClose = useCallback(() => {
        dispatch(closeDriversTagDeleteModal());
        dispatch(clearRedux("SETTINGS_DRIVER", {
            openDriversTagDelete: false,
            selectedItems: [],
            loading: false,
            loadingDelete: false
        }));
    });

    return (
        <Fragment>
            <Modal
                title={messages["settingsDriver_driversTagDelete"]}
                open={open}
                size="small"
                handleClose={handleClose}
                position="right"
                loading={loading || loadingDelete}
            >
                <ModalBody style={{ padding: 25 }}>
                    <Typography
                        variant="subtitle2"
                        color="textSecondary"
                    >
                        {messages["settingsDriver_descriptonDriversTagDelete"]}
                    </Typography>

                    <div style={{ marginTop: 10 }}>
                        {items?.map((item, key) => {
                            return (
                                <div key={key}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <Grid item>
                                            <Pill
                                                textField="label"
                                                item={{ ...item, label: item?.label?.length > 50 ? item?.label?.substring(0, 50) + "..." : item?.label }}
                                                outlined={false}
                                                style={{ margin: 5 }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <strong>{item?.driversCount}</strong>
                                        </Grid>
                                    </Grid>
                                </div>
                            )
                        })}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={handleClose}
                        className="btn-cancel"
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        id={'btn-schedule'}
                        type="button"
                        disabled={loadingDelete}
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            dispatch(deleteDriversTag({
                                items: items?.map(item => {
                                    return {
                                        tagId: item?.id,
                                        entityIds: [-1]
                                    }
                                })
                            }));
                        }}
                        className="btn-red"
                    >
                        {messages["remove"]}
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

export default DeleteDriversTag;